// window.addEventListener("scroll", fixedHeader)

// function fixedHeader() {
//   const windowHeight = window.innerHeight;
//   const target = document.querySelector(".l-header");
//   if(windowHeight < getScrollY()) {
//     target.classList.add("is-fixed")
//     target.classList.remove("is-hide")
//   } else {
//     target.classList.remove("is-fixed")
//     target.classList.add("is-hide")
//   }
// }

// fixedHeader();


// function getScrollY() {
//   if ('scrollY' in window) return window.scrollY;
//   if ('pageYOffset' in window) return window.pageYOffset;

//   const doc = window.document;

//   return doc.compatMode === 'CSS1Compat' ? doc.documentElement.scrollTop : doc.body.scrollTop;
// }